import { CobaltActionBar } from '@cae/cobalt-react/components/action-bar';
import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltLoaderCircular } from '@cae/cobalt-react/components/loader-circular';
import * as React from 'react';

import type { EditCitizenshipActionBarProps } from './EditCitizenshipActionBar.types';

const EditCitizenshipActionBar = React.memo(
  ({
    isMobile,
    isPending,
    isProfileReady,
    isDirty,
    onCloseAttempt,
    onSubmit,
  }: Readonly<EditCitizenshipActionBarProps>): React.ReactElement => (
    <CobaltActionBar
      position="right"
      variant="floating"
      mobile={isMobile}
      data-heap-id="edit-citizenship-action-bar"
      secondaryButton={
        <CobaltButton
          data-heap-id="profile-citizenship-cancel-btn"
          variant="secondary"
          onClick={onCloseAttempt}
          disabled={isPending}
        >
          Cancel
        </CobaltButton>
      }
      primaryButton={
        <CobaltButton
          data-heap-id="profile-citizenship-save-btn"
          variant="primary"
          onClick={onSubmit}
          disabled={isPending || !isProfileReady || !isDirty}
        >
          Save{isPending && <CobaltLoaderCircular size="small" />}
        </CobaltButton>
      }
    />
  )
);
EditCitizenshipActionBar.displayName = 'EditCitizenshipActionBar';

export { EditCitizenshipActionBar };
